import { render } from "./RecoveryPasswordPage.vue?vue&type=template&id=d4127466"
import script from "./RecoveryPasswordPage.vue?vue&type=script&lang=js"
export * from "./RecoveryPasswordPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/saas-stack/customer-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__